var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/WikiSearchResult.ts
import { A } from "@adornis/base/env-info.js";
import { logger } from "@adornis/base/logging.js";
import { Float } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { DataLoadedField } from "@adornis/baseql/decorators/data-loaded-field.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { WikiEntry } from "./WikiEntry.js";
var WikiChunkedSearchResult = class extends AdornisEntity {
  static resolveID(entity) {
    return "result_" + (entity.entryID ?? "unknown");
  }
};
WikiChunkedSearchResult._class = "WikiChunkedSearchResult";
__decorateClass([
  DataLoadedField((type) => WikiEntry, ({ entryID }) => entryID)
], WikiChunkedSearchResult.prototype, "entry", 2);
__decorateClass([
  Field((type) => String)
], WikiChunkedSearchResult.prototype, "entryID", 2);
__decorateClass([
  Field((type) => [WikiSearchResult])
], WikiChunkedSearchResult.prototype, "results", 2);
WikiChunkedSearchResult = __decorateClass([
  Entity()
], WikiChunkedSearchResult);
var WikiSearchResult = class extends AdornisEntity {
  static resolveID(entity) {
    return A.getGloballyUniqueID();
  }
  metaObject() {
    try {
      return JSON.parse(JSON.parse(this.meta ?? "{}"));
    } catch (e) {
      logger.error(e, "Failed to parse meta");
      return {};
    }
  }
  /**
   * Chunk wiki entries by their entryID
   * @param entries The entries to chunk
   * @returns The chunked entries
   */
  static ChunkByEntryID(entries) {
    const chunks = {};
    for (const entry of entries) {
      const id = entry.entryID ?? "unknown";
      if (!chunks[id]) {
        chunks[id] = [];
      }
      chunks[id].push(entry);
    }
    return chunks;
  }
};
WikiSearchResult._class = "WikiSearchResult";
__decorateClass([
  DataLoadedField((type) => WikiEntry, ({ entryID }) => entryID)
], WikiSearchResult.prototype, "entry", 2);
__decorateClass([
  Field((type) => String)
], WikiSearchResult.prototype, "entryID", 2);
__decorateClass([
  Field((type) => String)
], WikiSearchResult.prototype, "meta", 2);
__decorateClass([
  Field((type) => String)
], WikiSearchResult.prototype, "text", 2);
__decorateClass([
  Field((type) => Float)
], WikiSearchResult.prototype, "score", 2);
WikiSearchResult = __decorateClass([
  Entity()
], WikiSearchResult);
export {
  WikiChunkedSearchResult,
  WikiSearchResult
};
